import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"

import {
  API_SBP_OUTCOME_PAYMENTS_URL,
  TRANSACTION_STATUS_POLL_INTERVAL,
} from "../constants"
import { IGetSbpOutcomePaymentStatusResponse, OperationStatus } from "../interface"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

const FINAL_OUTCOME_PAYMENT_STATUSES: OperationStatus[] = [
  OperationStatus.ACCEPTED,
  OperationStatus.ACCEPT_ERROR,
  OperationStatus.REJECTED,
]

export async function getOutcomePaymentStatus(
  token: string | null,
  outcomePaymentId: string | undefined,
) {
  const response = await axios(
    `${API_SBP_OUTCOME_PAYMENTS_URL}/${outcomePaymentId}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка загрузки данных")
  }
  return response.data
}

export const useGetSbpOutcomePaymentStatus = (
  outcomePaymentId: string | undefined,
  enabled: boolean,
) => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<IGetSbpOutcomePaymentStatusResponse>({
    queryKey: ["sbp-outcome-payment-status", outcomePaymentId],
    queryFn: () => getOutcomePaymentStatus(token, outcomePaymentId),
    enabled: enabled && Boolean(outcomePaymentId) && Boolean(token),
    refetchInterval: (query) => {
      const status = query.state.data?.status
      if (status && FINAL_OUTCOME_PAYMENT_STATUSES.includes(status)) {
        return false
      }
      return TRANSACTION_STATUS_POLL_INTERVAL
    },
    refetchOnWindowFocus: false,
  })
}
